<template>
  <div>
    <div class="row">
      <div class="col">
        <p class="title">{{ message }}</p>
        <p class="description">
          {{
            $t(
              `message.spotlightV2.categories.${enums.SpotlightConstants.categories['INCENTIVES_AND_REBATES']}.${enums.SpotlightConstants.internalNames.autoverify['INCENTIVES-AND-REBATES']}.expire`
            ) +
            ' ' +
            expiry
          }}
        </p>
      </div>
      <div class="col pill-col align-middle">
        <div class="incentive">
          <p v-if="type === 'Cash'" class="value">
            {{ $n(value, 'currencyDollars', getLanguageCodeForNumericalInternationalization) }}
          </p>
          <p v-else-if="type === 'Percentage Based'" class="value">
            {{
              value +
              $t(
                `message.spotlightV2.categories.${enums.SpotlightConstants.categories['INCENTIVES_AND_REBATES']}.${enums.SpotlightConstants.internalNames.autoverify['INCENTIVES-AND-REBATES']}.percentOff`
              )
            }}
          </p>
          <p v-else-if="value === null" class="value">
            {{
              $t(
                `message.spotlightV2.categories.${enums.SpotlightConstants.categories['INCENTIVES_AND_REBATES']}.${enums.SpotlightConstants.internalNames.autoverify['INCENTIVES-AND-REBATES']}.noPrice`
              )
            }}
          </p>
        </div>
      </div>
    </div>
    <hr />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'IncentivesAndRebatesCard',
  props: {
    message: {
      validator: prop => typeof prop === 'string',
      required: true,
    },
    expiry: {
      validator: prop => typeof prop === 'string',
      required: false,
    },
    value: {
      validator: prop => typeof prop === 'number',
      required: false,
    },
    type: {
      validator: prop => typeof prop === 'string',
      required: false,
    },
  },
  computed: {
    ...mapGetters('user', ['getLanguageCodeForNumericalInternationalization']),
  },
};
</script>

<style scoped lang="scss">
@media only screen and (max-width: 429px) {
  .incentive {
    padding: 8px 12px;
    .value {
      line-height: 1.2;
    }
  }
}
.title {
  font-size: 18px;
  font-weight: bold;
  color: rgb(25, 34, 43);
  margin-bottom: 5px;
}

.description {
  font-size: 12px;
  color: rgb(109, 119, 131);
}

.incentive {
  background: var(--primary-light-background2);
  border-radius: 24px;
  display: inline-block;
  padding: 8px 32px;
  text-align: center;
}

.value {
  font-size: 14px;
  color: rgb(7, 100, 157);
  margin: 0;
}

.pill-col {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

hr {
  color: #dae2ea;
}
</style>
